// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3us_7","controls":"styles_controls__25iHE","charLimit":"styles_charLimit__2BnUl","input":"styles_input__ohCfg","send":"styles_send__5iV2Z"};